import { useState, useEffect } from 'react';
import { useAppSelector } from 'redux/hooks';
import { loginStatusSelector } from '@doda/common/src/redux/features/memberInfo';
import { postRecommend } from '@doda/common/src/services/postRecommend';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import type { RecommendLink } from 'components/RecommendLinks';

const DEFAULT_FORM_DATA = {
  recommendType: 'AWS_recommend',
  dispType: 'json',
  effectEventId: 'event70',
  effectPosition: 'Rekome_sp',
  effectName: 'none',
  conditionItems: '',
};

/**
 * レコメンドリンクを取得するカスタムフック
 *
 * @returns {RecommendLink | null} - レコメンドリンクのデータ
 */
export function useRecommendLinks(): RecommendLink | null {
  const [data, setData] = useState<RecommendLink | null>(null);
  const isLogin = useAppSelector(loginStatusSelector);

  useEffect(() => {
    if (!isLogin || data) return;

    postRecommend({
      ...DEFAULT_FORM_DATA,
      location: window.location.href,
    })
      .then((res) => {
        if (res.data?.searchLabel)
          setData({
            text: res.data.searchLabel,
            href: DODA_SITE_URL.intentionJobList,
          });
      })
      .catch(() => {
        // エラーの場合は非表示のまま
      });
  }, [isLogin, data]);

  return data;
}
